<template>
  <el-card>
    <h3 class="text-center">{{ this.message }}</h3>
  </el-card>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      message: "正在激活账户，请稍后"
    };
  },
  props: ["verification_token", "email"],
  methods: {
    ...mapMutations(["loginWithToken"])
  },
  computed: {
    ...mapState(["token"])
  },
  // set the layout to topic when it's mounted.
  mounted: function() {
    this.$axios
      .get(
        "/verification/check/" +
          this.verification_token +
          "?email=" +
          this.email
      )
      .then(() => {
        this.$message({
          type: "success",
          message: "激活成功， 正在跳转至登录页面"
        });
        this.message = "激活成功， 正在跳转至登录页面";
        let self = this;
        setTimeout(function() {
          self.$router.push("/login");
        }, 3000);
      })
      .catch(exception => {
        this.$message({
          type: "error",
          message: "激活不成功，请稍后再试: " + exception.response.data
        });
        this.message = "激活不成功，请稍后再试: " + exception.response.data;
      });
  }
};
</script>
